import React, { useState, useEffect } from "react";
import "./Products.css";
import { loadScript } from "./utils";
import { getProductList } from "../../../Apis/Setting";
import { placeOrderApi } from "../../../Apis/Order";
import Swal from "sweetalert2";
import Loader from "../../../Modules/Settings/Loader";
import { Link, useNavigate } from "react-router-dom";
import { FaRegCirclePlay } from "react-icons/fa6";


const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [comboItems, setComboItems] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [OrderResponse, setOrderResponse] = useState({});
  const [isorder, setIsOrder] = useState(true);
  const [isformfields, setisformfields] = useState(true);

  let navigate = useNavigate();

  const handleCheckboxChange = (addon) => {
    setSelectedAddons((prevSelected) => {
      const exists = prevSelected.some((item) => item.product_id?._id === addon.product_id?._id);
      return exists
        ? prevSelected.filter((item) => item.product_id?._id !== addon.product_id?._id)
        : [...prevSelected, addon];
    });
  };


  useEffect(() => {
    const fetchProductList = async () => {
      setLoadings(true);
      try {
        const productsData = await getProductList();
        console.log("productsData...", productsData);
        setProducts(productsData?.data);
        setComboItems(productsData?.data[0]?.comboItems);
        setIsOrder(productsData?.is_order_added);
        setisformfields(productsData?.is_form_flag);
      } catch (error) {
        console.error("Error fetching products:", error);

      } finally {
        setLoadings(false);
      }
    };
    fetchProductList();
  }, []);



  const subtotal =
    selectedAddons?.reduce((sum, addon) => sum + (addon?.product_id?.price || 0), 0) + (products[0]?.price || 0);

  const gst = subtotal * 0.18; // 18% GST
  const shipping = subtotal > 0 ? 50 : 0; // ₹50 shipping if any addon is selected
  const totalPrice = subtotal + gst + shipping;


  const handlePayment = async (product) => {
    try {
      setLoading(true);
      const orderData = {
        items: [
          {
            product_id: product._id,
            quantity: "1",
            ...(selectedAddons.length > 0 && { comboItems: selectedAddons }), // Conditionally add comboItems if they exist
          },
        ],
        total_price: totalPrice.toString(), // Ensure this includes add-ons in calculation
      };



      const orderResponse = await placeOrderApi(orderData);
      console.log("orderResponse", orderResponse);
      if (orderResponse?.statusCode !== 200) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Order Failed",
          text: orderResponse?.message || "Unable to place order. Try again.",
        });
        return;
      }

      const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      if (!res) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Payment Failed",
          text: "Razorpay SDK failed to load. Check your internet connection.",
        });
        return;
      }
      console.log("razorpay_res", res);
      const options = {
        key: "rzp_test_CtLgJ0Oux0mSi2",
        amount: subtotal * 100,
        currency: "INR",
        name: product?.title,
        order_id: orderResponse?.data?.id,
        // description: product.description,
        image: product?.product_image,


        // Swal.fire({
        //       icon: "sucess",
        //       title: "success!",
        //       text: ""
        //       showConfirmButton: true,
        //     });

        handler: (response) => {
          {
            // navigate("/order-list", { state: { orderData: orderResponse } }); // Navigate after success message
          };
        },
        prefill: {
          name: "Your Name",
          email: "your-email@example.com",
          contact: "9999999999",
        },
        theme: { color: "#e74c3c" },
      };


      const paymentObject = new window.Razorpay(options);
      console.log("paymentObject", paymentObject);
      paymentObject.open();
    } catch (error) {
      console.error("Error processing payment:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong during payment.",
      });
    } finally {
      setLoading(false);

    }

  };
  console.log("comboItems", comboItems);
  console.log("selectedAddons", selectedAddons);
  console.log("products", products);
  console.log("IsOrderstatus", isorder);
  return (
    <div className="product-container">
      <div className="container">

        <div className="px-3 py-3">
          {loadings && <Loader />}
          <h2 className="text-3xl font-bold mb-0 mb-md-3">Welcome Back!</h2>
          {/* {!isorder && ( */}
            <>
              <div className="row">
                <div className="col-md-4 mt-3 mt-md-0">
                  <div
                    className="custom-card"
                  >
                    <h2 className="text-sm font-medium">
                      Active Devices
                    </h2>
                    <p className="text-2xl font-bold mt-2 mb-0">0</p>
                    <div className="text-xs text-muted-foreground">Total devices in operation</div>
                  </div>
                </div>
                <div className="col-md-4 mt-3 mt-md-0">
                  <div
                    className="custom-card"
                  >
                    <h2 className="text-sm font-medium">
                      Tracking Status
                    </h2>
                    <p className="text-2xl font-bold mt-2 mb-0">NIL</p>
                    <div className="text-xs text-muted-foreground">Current tracking status</div>
                  </div>
                </div>
              </div>

              {products.map((product) => (
                <div key={product._id}
                  className="custom-card d-md-flex align-items-center mt-4 product-box-card"
                >
                  <div className="w-50 pe-5">
                    <div>
                      <h2 className="text-2xl font-bold mt-0 mb-3">{product.title}</h2>
                      <p className="text-muted-foreground mb-3">{product.description}</p>
                      <Link to="/buy" className="btn btn--form buy-now-btn">
                        Buy Now
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-4 w-4"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
                      </Link>
                      {/* <button
                  className="btn btn--form buy-now-btn"
                  onClick={() => handlePayment(product)}
                  disabled={loading} // Disable button when loading
                >
                  {loading ? (
                    <div className="loader mr-2"></div> // Simple loader
                  ) : null}
                  {loading ? "Processing..." : (
                    <>Buy Now <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-4 w-4"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
                    </>
                  )}
                </button> */}
                    </div>
                  </div>
                  <div className="w-50 ">
                    <div className="bg-muted rounded-xl h-570 w-100 d-flex align-items-center justify-content-center  p-4 position-relative">
                      <img
                        src={product.product_image}
                        alt={product.title}
                        className="product-image"
                      />
                    </div>
                  </div>
                </div>

              ))}
            </>
          {/* )} */}
         
          {isformfields === false && (
            <div
              className="custom-card d-flex align-items-center mt-4 complete-card"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-user-round h-12 w-12 text-primary"><path d="M18 20a6 6 0 0 0-12 0"></path><circle cx="12" cy="10" r="4"></circle><circle cx="12" cy="12" r="10"></circle></svg>
              <div class="ps-3">
                <h3 class="text-lg font-semibold mb-0">Complete Your Profile</h3>
                <p class="text-muted-foreground m-0">Update your profile with bank details and address to start ordering devices.</p>     </div>
              <div className="ms-auto">
                <Link to="/profile" className="btn btn--form update-profile-btn">
                  Update Profile
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default Products;
